import { get, isEmpty, isNil } from 'lodash';
import { NEW_EXISTING_RADIO_STATE_KEY } from '@zocdoc/components/src/newexistingradio/NewExistingRadioSelector';
import { getProfilePageParameters } from '../../state/selectors';

export const mapStateToProps = state => {
    const initParams = get(getProfilePageParameters(state), 'initParameters') || {};

    const radioState = isEmpty(state[NEW_EXISTING_RADIO_STATE_KEY])
        ? { isNewPatient: !isNil(initParams.isNewPatient) ? initParams.isNewPatient : true }
        : state[NEW_EXISTING_RADIO_STATE_KEY];

    return {
        defaultValue: radioState.isNewPatient ? 'new-patient' : 'existing-patient',
    };
};
